import React, { useMemo } from "react";
import { Link } from "react-router-dom"; 
import { useSelector } from "react-redux";
import {Loader} from './Loader';
import "./Breadcrumbs.scss";

const Breadcrumbs = ({ data = {} }) => {
  const { categories = [] } = useSelector((state) => state.category || {});
  const { subcategories = [] } = useSelector((state) => state.subcategories || {});
  const { subsubcategories = [] } = useSelector((state) => state.subsubcategories || {});

  const { subProduct = null } = data;

  const firstCategory = useMemo(() => {
    const categoryId = data.category?.[0];
    return categories.find((c) => c._id === categoryId) || null;
  }, [categories, data.category]);

  const firstSubcategory = useMemo(() => {
    const subcategoryId = data.subcategory?.[0];
    return subcategories.find((sc) => sc._id === subcategoryId) || null;
  }, [subcategories, data.subcategory]);

  const firstSubSubcategory = useMemo(() => {
    const subsubcategoryId = data.subsubcategory?.[0];
    return subsubcategories.find((ssc) => ssc._id === subsubcategoryId) || null;
  }, [subsubcategories, data.subsubcategory]);

  const isLoading = useMemo(() => {
    return (
      categories.length === 0 ||
      (data.category?.length > 0 && firstCategory === null) ||
      (data.subcategory?.length > 0 && firstSubcategory === null) ||
      (data.subsubcategory?.length > 0 && firstSubSubcategory === null)
    );
  }, [
    categories,
    firstCategory,
    firstSubcategory,
    firstSubSubcategory,
    data,
  ]);

  if (isLoading) {
    return (
      <nav aria-label="breadcrumb" className="breadcrumb-container">
        <ol className="breadcrumb-list">
          <li className="breadcrumb-item"><Loader/></li>
        </ol>
      </nav>
    );
  }

  return (
    <nav aria-label="breadcrumb" className="breadcrumb-container">
      <ol className="breadcrumb-list">
        <li className="breadcrumb-item">
          <Link to="/" className="breadcrumb-link">
            Головна сторінка
          </Link>
        </li>
        
        {firstCategory && (
          <>
            <li className="breadcrumb-separator">&gt;</li>
            <li className="breadcrumb-item">
              <Link
                to={`/products/${firstCategory._id}`}
                className="breadcrumb-link"
              >
                {firstCategory.name}
              </Link>
            </li>
          </>
        )}

        {firstSubcategory && (
          <>
            <li className="breadcrumb-separator">&gt;</li>
            <li className="breadcrumb-item">
              <Link
                to={`/productss/${firstSubcategory._id}`}
                className="breadcrumb-link"
              >
                {firstSubcategory.name}
              </Link>
            </li>
          </>
        )}

        {firstSubSubcategory && (
          <>
            <li className="breadcrumb-separator">&gt;</li>
            <li className="breadcrumb-item">
              <Link
                to={`/items/${firstSubSubcategory._id}`}
                className="breadcrumb-link"
              >
                {firstSubSubcategory.name}
              </Link>
            </li>
          </>
        )}


        {(subProduct && subProduct.name) ? (
          <>
            <li className="breadcrumb-separator">&gt;</li>
            {data.name && (
              <>
                <li className="breadcrumb-item">
                  <Link
                    to={`/product/${data._id}`}
                    className="breadcrumb-link"
                  >
                    {data.name}
                  </Link>
                </li>
                <li className="breadcrumb-separator">&gt;</li>
              </>
            )}
            <li className="breadcrumb-item breadcrumb-item--last">
              {subProduct.name}
            </li>
          </>
        ) : (
          data.name && (
            <>
              <li className="breadcrumb-separator">&gt;</li>
              <li className="breadcrumb-item breadcrumb-item--last">
                {data.name}
              </li>
            </>
          )
        )}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
